import { useState } from 'react';

import { useModals } from '@mantine/modals';

import { useNavigate } from '@tanstack/react-router';

import { Button } from '@optiro/ui';

import { EnterTrialGate } from '@/components/EnterTrialGate';
import { FormValues, ProjectForm } from '@/components/Forms/ProjectForm';
import useCreateProject from '@/hooks/projects/useCreateProject';
import { useAuth } from '@/providers/AuthProvider/AuthProvider';

export const ProjectSettingsModal = () => {
  const { userData, refetchUserData } = useAuth();
  const navigate = useNavigate();
  const createProject = useCreateProject();
  const modals = useModals();
  const [trialGateOpen, setTrialGateOpen] = useState(false);

  const handleSubmit = (values: FormValues) => {
    createProject.mutate(
      {
        name: values.name,
        manager_ids: values.manager_ids,
        category_id: values.category_id,
        client_name: values.client_name,
      },
      {
        onSuccess: (data) => {
          modals.closeModal('project-settings');
          navigate({
            to: '/app/projects/$projectId',
            params: { projectId: String(data.id) },
            search: { tab: undefined },
          });
        },
      }
    );
  };

  const openContentModal = () =>
    modals.openModal({
      modalId: 'project-settings',
      title: 'Tilføj projekt',
      size: 'lg',
      children: (
        <ProjectForm
          mode="create"
          onClose={() => modals.closeAll()}
          defaultValues={{
            manager_ids: userData?.id ? [userData.id] : [],
          }}
          onSubmit={handleSubmit}
        />
      ),
    });

  const handleButtonClick = () => {
    if (userData?.company.status === 'collab') {
      setTrialGateOpen(true);
      return;
    }
    openContentModal();
  };

  return (
    <div>
      <Button size="sm" onClick={handleButtonClick} data-testid="create-project-button">
        Tilføj Projekt
      </Button>
      <EnterTrialGate
        opened={trialGateOpen}
        onClose={() => setTrialGateOpen(false)}
        onSuccess={async () => {
          setTrialGateOpen(false);
          await refetchUserData();
          openContentModal();
        }}
      />
    </div>
  );
};

export default ProjectSettingsModal;
